module.exports = "<calculator pages=\"$ctrl.pages\"\n            step-selector=\"$ctrl.stepSelector\"\n            matter-type=\"$ctrl.matterType\">\n</calculator>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/sale/sale.html
// module id = 483
// module chunks = 0